import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { CardModule } from "../card/card.module";
import { CardExpandedComponent } from "./card-expanded.component";

@NgModule({
  declarations: [CardExpandedComponent],
  imports: [CommonModule, CardModule, MatDialogModule],
})
export class CardExpandedModule {}
